import {
    SUPER_ROLE,
    HR_SUPER_ROLE,
    INITIATOR_ROLE,
    EXTERNAL_ROLE,
    IUserInfo
} from "../users-service-types";

export type IPermissions = Record<string, string[]>;

const PERMISSIONS: IPermissions = {
    canSeeYandexProcureForm: [INITIATOR_ROLE],
    canCreateTemplateGroups: [SUPER_ROLE],
    canSeeRoleMatrix: [HR_SUPER_ROLE, SUPER_ROLE]
}

export const hasPermission = (roles: IUserInfo["roles"] | undefined, permission: keyof IPermissions) => {
    if (roles && PERMISSIONS.hasOwnProperty(permission)) {
        return PERMISSIONS[permission as any].some(role => roles.includes(role));
    } else {
        return false;
    }
}
